"use client";

import { useProductStore } from "@/lib/store/product.store";
import { formatPrice } from "@/lib/utils";

type Props = {
	price: string | number;
	className?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
};
export default function Price(props: Props) {
	const { price, className = "", size = "lg" } = props;
	const { currencyUnit } = useProductStore();
	if (+price <= 0) return null;
	const pce = price?.toString().startsWith(currencyUnit)
		? price
		: `${currencyUnit} ${formatPrice(price?.toString())}`;
	return <span className={`${className} text-${size} !font-poppins py-2  `}>{pce}</span>;
}
